/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description Configure message for listing
 */

import type {
  InitialMessageData,
  Listable,
  MessageDataForListing,
  Property,
} from '@zcode/state-type'
import type { Mutable } from '@zcode/utility-types'

const configureForListing = (
  messageData: Mutable<InitialMessageData>,
  listing: (Listable | Property) & { isBuilding?: false | undefined }
): asserts messageData is Mutable<MessageDataForListing> => {
  if (!listing) {
    return
  }
  const extras: Pick<
    Mutable<MessageDataForListing>,
    'listing' | 'listingIds' | 'messagedListingIds'
  > = {
    listing,
    listingIds: [listing.listingId],
    messagedListingIds: [listing.listingId],
  }
  // listing config definition
  Object.assign(messageData, extras)
}

export default configureForListing
